import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  Reference,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import { transformTracks } from './tracks.transformers';
import { TracksCollection } from './tracks.types';

export function tracksReducer(
  state: CollectionStateSlice<TracksCollection> = {},
  action: CollectionActions<TracksCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'tracks') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<TracksCollection>(
          state,
          transformIntoDocuments(result, transformTracks),
          order,
          ref,
        );
      }
      return state;
    }
    case 'WS_MESSAGE': {
      const ref: Reference<TracksCollection> = {
        path: {
          collection: 'tracks',
          authUid: action.payload.toUserId,
        },
      };
      if (
        action.payload.parent_type === 'notifications' &&
        action.payload.type === 'trackUpdate'
      ) {
        const trackPoint = {
          longitude: action.payload.data.longitude,
          latitude: action.payload.data.latitude,
        };
        return updateWebsocketDocuments<TracksCollection>(
          state,
          [action.payload.data.trackId],
          track => ({
            ...track,
            trackPoints: [...track.trackPoints, trackPoint],
          }),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
